module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_3.4e32114d.png";